import type { Theme } from '@emotion/react';
import { css } from '@emotion/react';
import { sizes } from './typography';

// prettier-ignore
export const base = (theme: Theme) => css`
  html,
  body {
    min-height: 100vh;
    font-family: ${theme.font.family}, sans-serif;
    font-weight: 400;
    color: ${theme.colors.foreground};
    max-width: 100%;
    margin: 0;
  }
  html {
    -webkit-overflow-scrolling: touch;
    overflow-x: hidden;
    /* always show the vertical scrollbar so that content doesn't jump */
    overflow-y: scroll;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    box-sizing: border-box;
    background-color: ${theme.colors.primary};
  }
  #atlwdg-trigger {
    display: none !important;
  }
  svg {
    transform: translate3d(0px, 0px, 0px);
  }
  .lazyloading {
    filter: blur(10px);
  }

  .lazyloaded {
    filter: blur(0px);
  }

  .no-js .lazyloading {
    filter: blur(0px);
  }

  .no-js [style*='opacity:0'] {
    opacity: 1 !important;
  }

  .no-js [style*='transform'] {
    transform: none !important;
  }

  .grecaptcha-badge {
    visibility: hidden;
  }

  /* inherited from <html> */
  *,
  *::before,
  *::after {
    box-sizing: inherit;
  }

  body {
    font-size: ${sizes.bodySize}px;
    position: relative;
    margin: 0;
    font-family: ${theme.font.family}, sans-serif;
    line-height: ${sizes.bodyLineHeight / sizes.bodySize};
    /* iOS on orientation change */
    text-size-adjust: 100%;
    color: ${theme.colors.foreground};
    @media (min-width: ${theme.breakpoints.lg.width}) {
      font-size: ${sizes.bodySize};
    }
    background-color: white;
  }

  html.is-scroll-disabled body {
    height: 100vh;
    overflow: hidden;
  }

  @media screen and (-ms-high-contrast: active),
    screen and (-ms-high-contrast: none) {
    html.is-scroll-disabled body {
      overflow: visible;
      height: auto;
    }
  }

  img {
    display: block;
    max-width: 100%;
    height: auto;
    opacity: 1;
  }

  /* placeholders */
  input,
  textarea,
  select {
    &::placeholder {
      opacity: 1;
      color: ${theme.colors.primary};
    }
  }
  a,
  input,
  select,
  button {
    outline: none;
    &:focus:not(:active) {
      outline: 1px dashed #666;
    }
    .focus-with-mouse & {
      &:focus:not(:active) {
        outline: 0;
      }
    }
  }

  ::selection {
    background: ${theme.shades.secondary1};
  }

  input[type='text']::selection {
    background: ${theme.shades.secondary3};
  }
  sub,
  sup {
    font-size: 14px;
    line-height: 14px;
  }
`;
